import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useWorkbooks } from '../contexts/WorkbookContext';
import logo from '../images/txedlif-logo1.png';
import '../styles/sheetviewer.css';

const SheetViewer = () => {
    const { workbookName, sheetName } = useParams();
    const [rows, setRows] = useState([]);
    const workbooks = useWorkbooks();
    const wb = workbooks.find(w => w.name === workbookName);
    const sheets = wb?.sheets || [];

    // flip this to true when you need debug info
    // [CURRENTLY] only shows table cell location and if a cell is empty
    const [debugMode] = useState(false);

    // Used to setup row amounts to view in a page
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const pageCount = Math.ceil(rows.length / pageSize);
    const pageRows = rows.slice(page * pageSize, (page + 1) * pageSize);

    useEffect(() => {
        const encodedWorkbook = encodeURIComponent(workbookName);
        const encodedSheet = encodeURIComponent(sheetName);

        fetch(`/bilingual_mapping_tool/api/workbooks/${encodedWorkbook}/sheets/${encodedSheet}/data`)
            .then((res) => res.json())
            .then((data) =>setRows(data))
            .catch((err) => console.error("Error fetching sheet data:", err));
    }, [workbookName, sheetName]);

    return (
        
        <div className='sheet-container'>

            {/* Shows what sheet we are looking at */}
            <h1 style={{color: '#0d6cb9'}}>{workbookName}</h1>
            <h2 style={{color: '#0d6cb9'}}>{sheetName}</h2>

            {/* Sheet-Tab Navigation */}
            <nav className="sheet-tabs">
                {sheets.map(name => (
                    <Link
                        key={name}
                        to={`/view/${encodeURIComponent(workbookName)}/${encodeURIComponent(name)}`}
                        className={name === sheetName ? 'tab active' : 'tab'}
                    >
                        {name}
                    </Link>
                ))}
            </nav>
                
            {/* Pagination Controls */}
            <div className="pagination-controls">

                <button onClick={() => setPage(p => Math.max(p-1, 0))} disabled={page===0}>
                    Prev
                </button>

                {/* Page-size selector */}
                <select 
                    value={pageSize} 
                    onChange={e => {
                    setPageSize(+e.target.value);
                    setPage(0);        // reset to first page
                    }}
                    style={{ margin: '0 1rem' }}
                >
                    {[10, 25, 50, 75, 100, 150, 200].map(n => 
                    <option key={n} value={n}>{n} rows</option>
                    )}
                </select>

                <button 
                    onClick={() => setPage(p => Math.min(p+1, pageCount-1))}
                    disabled={page===pageCount-1}
                >
                    Next
                </button>

                <span style={{ marginLeft: '1rem', color: 'initial' }}>
                    Page {page+1} of {pageCount}
                </span>

            </div>

            {/* how the excel sheet gets displayed */}
            <div className="table-wrapper">
                <table>
                    <tbody>

                        {/* table rows */}
                        {pageRows.map((row, rowIndex) => (
                            <tr key={rowIndex}>

                                {/* table cells */}
                                {row.map((cell, colIndex) => (
                                    <td key={colIndex}
                                        className={(!cell.value?.trim() && !cell.base64Image) ? 'empty-cell' : ''}
                                        colSpan={cell.colSpan > 1 ? cell.colSpan : undefined}
                                        rowSpan={cell.rowSpan > 1 ? cell.rowSpan : undefined}
                                        style={{
                                                backgroundColor: cell.backgroundColor || '#ffffff',
                                                padding: '0.75rem 1rem',
                                                border: '1px solid #e0e0e0',
                                                whiteSpace: 'break-spaces',
                                                textAlign: 'center',
                                            }
                                        }
                                    >
                                        <div className="cell-content">
                                            {cell.value === '#VALUE!' ? (

                                                /* logo banner: frontend\public\images\txedlif-logo.png */
                                                <img src={logo} alt='' style={{maxWidth: '200px', display: 'block', margin: 'auto'}} />

                                                ) : cell.base64Image ? (

                                                    /* images in the excel files */
                                                    <img src={cell.base64Image} alt=''className='table-image' />

                                                ) : cell.value?.trim() ? (

                                                    /* text in the excel files w/ sytling */
                                                    <span style={{
                                                        fontWeight: cell.bold ? 'bold' : 'normal',
                                                        fontStyle: cell.italic ? 'italic' : 'normal',
                                                        color: cell.textColor ?? 'initial'
                                                    }}>
                                                        {cell.value}
                                                    </span>

                                                ) : (debugMode && 

                                                    /* [debugMode=true] Prints a label on cells that are empty and where on the table*/
                                                    <span style={{ color: 'blue', fontSize: '10px' }}>
                                                        [empty]
                                                    </span>

                                                )
                                            }

                                            {/* [debugMode=true] Prints a label where cells are on the table */}
                                            {debugMode && (
                                                <div style={{ fontSize: '10px', color: 'green' }}>
                                                    ({rowIndex},{colIndex}) [{cell.rowSpan}x{cell.colSpan}]
                                                </div>
                                            )}
                                        </div>
                                    </td>   
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SheetViewer;